import {define, html, store, router, Descriptor} from "hybrids";
import ArtistVideo from "~/stores/ArtistVideo";
import Course from "~/stores/Course";

interface VViewDonateConfirmView {
  video: ArtistVideo;
  status: string;
}

export default define<VViewDonateConfirmView>({
  [router.connect]: {
    url: "/watch/:video/confirm?status",
  },
  tag: "v-view-donate-confirm-view",
  video: store(ArtistVideo) as Descriptor<VViewDonateConfirmView, ArtistVideo>,
  status: "",
  content: ({status}) => html`
    ${status === "succeeded" &&
    html`
      <v-broadcast-nav-bar close>Success!</v-broadcast-nav-bar>
      <v-ui-text>
        Thank you for your donation.
      </v-ui-text>
    `}
    ${status === "processing" &&
    html`
      <v-broadcast-nav-bar close>Payment processing</v-broadcast-nav-bar>
      <v-ui-text>
        We'll update you when payment is received.
      </v-ui-text>
    `}
    ${status === "requires_action" &&
    html`
      <v-broadcast-nav-bar close>Payment requires action</v-broadcast-nav-bar>
      <v-ui-text>
        Your payment requires action, please contact your payment provider.
      </v-ui-text>
    `}
    ${["requires_payment_method", "requires_source", "canceled"].includes(status) &&
    html`
      <v-broadcast-nav-bar close>Payment failed</v-broadcast-nav-bar>
      <v-ui-text>
        Payment failed or was canceled. Please try again.
      </v-ui-text>
    `}
  `,
});
